export enum SuccessSnackbarDataCy {
    SNACK_BAR = 'snack-bar',
}
